/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface WorkGeoLocationPointDTO
 */
export interface WorkGeoLocationPointDTO  {
    /**
     * 
     * @type {number}
     * @memberof WorkGeoLocationPointDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkGeoLocationPointDTO
     */
    latitude?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkGeoLocationPointDTO
     */
    longitude?: string;
}

/**
 * Check if a given object implements the WorkGeoLocationPointDTO interface.
 */
export function instanceOfWorkGeoLocationPointDTO(value: object): value is WorkGeoLocationPointDTO {
    return true;
}

export function WorkGeoLocationPointDTOFromJSON(json: any): WorkGeoLocationPointDTO {
    return WorkGeoLocationPointDTOFromJSONTyped(json, false);
}

export function WorkGeoLocationPointDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkGeoLocationPointDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'latitude': json['latitude'] == null ? undefined : json['latitude'],
                  'longitude': json['longitude'] == null ? undefined : json['longitude'],
    };
}

export function WorkGeoLocationPointDTOToJSON(json: any): WorkGeoLocationPointDTO {
    return WorkGeoLocationPointDTOToJSONTyped(json, false);
}

export function WorkGeoLocationPointDTOToJSONTyped(value?: WorkGeoLocationPointDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
    };
}


